<template>
  <div>
    <PesquisaLote @recebeFiltrosPesquisa="recebeFiltrosPesquisa"
                  @changeTipoPesquisa="changeTipoPesquisa" />

    <OptionsLote v-if="livros.length > 0 || registros.length > 0"
                 :page="page"
                 :per-pag="perPage"
                 :last-page="lastPage"
                 :accept-select-all="registros.length === selectedRegisters.length"
                 :show-all-info="true"
                 :enable-select-all="registros.length > 0"
                 @selectAllFiles="selectedAllRegistros"
                 @nextPage="nextPage"
                 @previousPage="previousPage"
                 @notAccepted="notAccept"
                 @updatePerPage="updatePerPage" />

    <ListagemLoteLivros v-if="tipoPesquisa === 'LIVRO' && livros.length > 0"
                        class="mt-3 ml-2 pr-3"
                        :livros="livros" />

    <ListagemLoteRegistro v-if="tipoPesquisa === 'REGISTRO' && registros.length > 0"
                          class="mt-3 ml-2 pr-3"
                          :items="registros"
                          :selected-all="selectedAll"
                          @onSelectRegisters="selectRegisters" />

    <OptionsLote v-if="livros.length > 0 || registros.length"
                 :page="page"
                 :last-page="lastPage"
                 :show-all-info="false"
                 @nextPage="nextPage"
                 @previousPage="previousPage" />
    
    <BoxConfirmaLoteRegistros v-if="registros.length > 0 && tipoPesquisa === 'REGISTRO'"
                              :registros="registros"
                              :selected-registers="selectedRegisters"
                              @confirmaRegistros="confirmaRegistros" />
  </div>
</template>

<script>
  import moment from 'moment'

  /* components */
  import OptionsLote from '@/components/SofiaRei/ImportarImagensEmLote/OptionsLote'
  import PesquisaLote from '@/components/SofiaRei/ImportarImagensEmLote/PesquisaLote'
  import ListagemLoteLivros from '@/components/SofiaRei/ImportarImagensEmLote/ListagemLoteLivros'
  import ListagemLoteRegistro from '@/components/SofiaRei/ImportarImagensEmLote/ListagemLoteRegistro'
  import BoxConfirmaLoteRegistros from '@/components/SofiaRei/ImportarImagensEmLote/BoxConfirmaLoteRegistros'

  /* services */
  import LivroService from '@/services/LivroService'
  import RegistrosService from '@/services/Registros'

  export default {
    name: 'InicioImportacaoImagensEmLote',
    components: {
      OptionsLote,
      PesquisaLote,
      ListagemLoteLivros,
      ListagemLoteRegistro,
      BoxConfirmaLoteRegistros
    },
    data () {
      return {
        // Filtros da pesquisa
        pesquisa: null,
        tipoPesquisa: null,

        // Paginação
        page: 1,
        perPage: 100,
        lastPage: 1,

        // Resultado pesquisa
        livros: [],
        registros: [],

        // Seleção de registros
        notAccepted: false,
        selectedAll: false,
        selectedRegisters: []
      }
    },
    methods: {
      // Filtros da pesquisa
      recebeFiltrosPesquisa (val) {
        this.pesquisa = { ...val.pesquisa }
        this.tipoPesquisa = val.tipoPesquisa

        this.page = 1

        this.livros = []
        this.registros = []
        this.selectedRegisters = []

        return this.tipoPesquisa === 'LIVRO' ? this.searchLivro() : this.searchRegistro()
      },
      changeTipoPesquisa (val) {
        this.tipoPesquisa = val

        this.page = 1
        
        this.livros = []
        this.registros = []
        this.selectedRegisters = []
      },
      async searchLivro () {
        loader({ text: 'Buscando dados...', active: true })

        this.pesquisa = {
          tipoLivro: this.pesquisa.tipoLivro,
          numLivro: this.pesquisa.numLivro,
          perPage: this.perPage,
          page: this.page
        }

        try {
          // Deixamos no payload só as keys que tem algum valor do objeto de pesquisa
          const payload = Object.fromEntries(Object.entries(this.pesquisa).filter(([_, key]) => !!key))

          const { data, page, lastPage } = await LivroService.getLivrosImportacaoEmLote(payload)

          const livros = data.filter(livro => livro.qtd_registros > 0)

          this.livros = livros
          this.page = page
          this.lastPage = lastPage

          if (!this.livros.length) {
            this.infoSwall('Nenhum livro encontrado')
          }
        } catch (e) {
          console.error(e)
          this.infoSwall('Nenhum livro encontrado')
        } finally {
          loader({ text: '', active: false})
        }
      },
      async searchRegistro () {
        loader({ text: 'Buscando dados...', active: true })

        this.pesquisa = {
          ...this.pesquisa,
          perPage: this.perPage,
          page: this.page
        }

        try {
          // Deixamos no payload só as keys que tem algum valor do objeto de pesquisa
          let payload = Object.fromEntries(Object.entries(this.pesquisa).filter(([_, key]) => !!key))

          if (payload.dataRegistroInicio) {
            payload.dataRegistroInicio = moment(payload.dataRegistroInicio, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }

          if (payload.dataRegistroFim) {
            payload.dataRegistroFim = moment(payload.dataRegistroFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }

          if (payload.dataOcorridoInicio) {
            payload.dataOcorridoInicio = moment(payload.dataOcorridoInicio, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }

          if (payload.dataOcorridoFim) {
            payload.dataOcorridoFim = moment(payload.dataOcorridoFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }

          const { data, page, lastPage } = await RegistrosService.getRegistrosImportacaoEmLote(payload)

          this.registros = data
          this.page = page
          this.lastPage = lastPage

          if (!this.registros.length) {
            this.infoSwall('Nenhum registro encontrado')
          }
        } catch (e) {
          console.error(e)
          this.infoSwall('Nenhum registro encontrado')
        } finally {
          loader({ text: '', active: false})
        }
      },
      infoSwall (text) {
        objSwal.info.title = ''
        objSwal.info.text = text || 'Nenhum dado encontrado'
        objSwal.info.html = ''
            
        Swal.fire(objSwal.info)

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 200)
      },

      // Paginação
      selectedAllRegistros (val) {
        this.selectedAll = val
      },
      nextPage (nextPag) {
        this.page = nextPag
        this.unCheckRegistos()
      },
      previousPage (previousPag) {
        this.page = previousPag
        this.unCheckRegistos()
      },
      updatePerPage (val) {
        this.perPage = val
        this.page = 1
        this.unCheckRegistos()
      },
      unCheckRegistos () {
        this.selectedAll = false
        this.selectedRegisters = []
        this.notAccepted = true

        return this.tipoPesquisa === 'LIVRO' ? this.searchLivro() : this.searchRegistro()
      },

      // Seleção de registros
      notAccept () {
        this.notAccepted = false
      },
      selectRegisters (list) {
        this.selectedRegisters = list
      },
      confirmaRegistros (val) {
        this.selectedRegisters = val.sort((a, b) => { a.registro_id - b.registro_id })

        this.$store.dispatch('lote/updateLoteRegistrosSelecionados', this.selectedRegisters)

        this.$router.push({ name: 'lote_registro' })
      }
    }
  }
</script>
